"use strict";

var cov_17gzwd39s8 = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/authentication/useStyles.js";
  var hash = "957b01eda8c42a6bcc32ebcaca76242ddd42ad27";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/authentication/useStyles.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 25
        },
        end: {
          line: 30,
          column: 3
        }
      },
      "1": {
        start: {
          line: 3,
          column: 46
        },
        end: {
          line: 30,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 36
          },
          end: {
            line: 3,
            column: 37
          }
        },
        loc: {
          start: {
            line: 3,
            column: 46
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 3
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "957b01eda8c42a6bcc32ebcaca76242ddd42ad27"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (cov_17gzwd39s8.s[0]++, (0, _styles.makeStyles)(function (theme) {
  cov_17gzwd39s8.f[0]++;
  cov_17gzwd39s8.s[1]++;
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: "".concat(theme.spacing(2), "px ").concat(theme.spacing(3), "px ").concat(theme.spacing(3), "px")
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.primary.main
    },
    form: {
      width: '100%',
      // Fix IE 11 issue.
      marginTop: theme.spacing(1)
    },
    submit: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2)
    },
    footer_container: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    footer_column: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  };
}));
exports.useStyles = useStyles;